const fetchWorkflows = async ({ commit, rootGetters, dispatch }, payload) => {
  commit('SET_FETCH_AUTOMATION_WORKFLOWS_LOADING', true);
  try {
    const customer = rootGetters['customer/CUSTOMER'];
    const selected_customer = rootGetters['customer/SELECTED_CUSTOMER'];

    let url = '/proxy/get-workflows';

    let customer_id = customer.customer_id;

    if (customer_id === 0) {
      customer_id = selected_customer.customer_id;
    }

    const data = {
      customer_id,
      ...payload,
    };

    const response = await window.axios.post(url, data);

    if (response && response.data.success) {
      commit('SET_AUTOMATION_WORKFLOWS', response.data.workflows);
      commit('SET_AUTOMATION_WORKFLOWS_COUNT', response.data.count);
    } else {
      throw response.data;
    }
  } catch (error) {
    dispatch('notifications/setError', error.message, { root: true });
  } finally {
    // stuff here
    commit('SET_FETCH_AUTOMATION_WORKFLOWS_LOADING', false);
  }
};

export default fetchWorkflows;
